import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const goTo = (id) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
      return;
    }

    if (id === "home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const section = document.getElementById(id);
    if (section) section.scrollIntoView({ behavior: "smooth" });
  };

  const quickLinks = [
    { id: "home", label: "Home" },
    { id: "clients", label: "Clients" },
    { id: "about", label: "About" },
    { id: "products", label: "Products" },
    { id: "spares", label: "Spares" },
    { id: "capabilities", label: "Capabilities" },
    { id: "certification", label: "Certification" },
    { id: "approval", label: "Approval" },
    { id: "services", label: "Services" },
  ];

  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        bgcolor: "#efdcaf",
        color: "#686868",
        py: 4,
        px: { xs: 3, md: 10 },
        fontFamily: "Roboto, sans-serif",
        borderTop: "1px solid #2d2075",
      }}
    >
      <Grid container spacing={4}>

        {/* LOGO */}
        <Grid item xs={12} md={3}>
          <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
            <img
              src="/logo.png"
              alt="Multitex Filters Pvt. Ltd."
              style={{ height: 60 }}
            />
          </Box>
        </Grid>

        {/* QUICK LINKS */}
        <Grid item xs={12} md={5}>
          <Typography
            component="h2"
            sx={{
              fontSize: "20px",
              fontWeight: 700,
              mb: 2,
              lineHeight: 1.5,
              color: "#2d2075", // ✅ ONLY heading color
            }}
          >
            Quick Links
          </Typography>

          <Grid container spacing={1}>
            {quickLinks.map((item) => (
              <Grid item xs={6} key={item.id}>
                <Box
                  component="button"
                  onClick={() => goTo(item.id)}
                  sx={{
                    all: "unset",
                    cursor: "pointer",
                    display: "inline-block",
                    fontSize: "16px",
                    lineHeight: 1.5,
                    fontFamily: "Roboto, sans-serif",
                    color: "#686868",
                    textDecoration: "underline",
                    px: 1.5,
                    py: 0.6,
                    borderRadius: "6px",
                    transition: "all 0.25s ease",

                    "&:hover": {
                      backgroundColor: "#2d2075",
                      color: "#ffffff",
                      textDecoration: "none",
                    },

                    "&:focus-visible": {
                      outline: "2px solid #686868",
                      outlineOffset: "2px",
                    },
                  }}
                >
                  {item.label}
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* HEAD OFFICE */}
        <Grid item xs={12} md={4}>
          <Typography
            component="h2"
            sx={{
              fontSize: "20px",
              fontWeight: 700,
              mb: 2,
              lineHeight: 1.5,
              color: "#2d2075", // ✅ ONLY heading color
            }}
          >
            Head Office
          </Typography>

          <Typography sx={{ fontSize: "16px", lineHeight: 1.5 }}>
            217, Hans Bhawan<br />
            Bahadur Shah Zafar Marg<br />
            New Delhi 110002, India
          </Typography>

          <Typography sx={{ fontSize: "16px", lineHeight: 1.5, mt: 1 }}>
            +91 11 42404040
          </Typography>
        </Grid>
      </Grid>

      {/* COPYRIGHT */}
      <Box
        sx={{
          borderTop: "1px solid #686868",
          mt: 4,
          pt: 2,
          textAlign: "center",
        }}
      >
        <Typography sx={{ fontSize: "14px", lineHeight: 1.5 }}>
          © 2025 Multitex Filters Pvt. Ltd. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
}
